export function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
export function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}



//////////////////
// WEBPACK FOOTER
// ./~/@aws-sdk/util-utf8-browser/dist-es/whatwgEncodingApi.js
// module id = 525
// module chunks = 0